import React from "react";
import Alert from "@mui/material/Alert";
const SuccessAlert = ({ children }) => (
  <Alert
    className="alert-animation"
    style={{ marginTop: "3px", marginBottom: "1%", background: "#99dda283", color: "#eee" }}
  >
    {children}
  </Alert>
);
export default SuccessAlert;
